class ProductTile extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener('click', this.handleVariantSwatchClick.bind(this));
    this.addEventListener('keydown', this.handleVariantSwatchKeydown.bind(this));

    if (document.readyState === 'complete') {
      this.iniFeaturesSlider();
    } else {
      document.addEventListener('DOMContentLoaded', () => {
        this.iniFeaturesSlider();
      });
    }
  }

  handleVariantSwatchClick(e) {    
    const variantSwatch = e.target.closest('[data-variant-swatch]');
    if (!variantSwatch) return;

    const {
      variantId,
      variantImage,
      variantComparePrice,
      variantPrice,
      variantCtaLabel
    } = variantSwatch.dataset;    

    this.updateProductDetails(variantImage, variantComparePrice, variantPrice, variantCtaLabel);
    this.updateVariantSelection(variantSwatch);
    this.updateAtcInput(variantId, variantSwatch.disabled);
  }

  handleVariantSwatchKeydown(e) {
    const variantSwatch = e.target.closest('[data-variant-swatch]');
    if (!variantSwatch) return;
  
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      this.handleVariantSwatchClick(e);
    }
  }

  iniFeaturesSlider() {
    const sliderWrappers = document.querySelectorAll('[data-features-slider-wrapper]');

    sliderWrappers.forEach((sliderWrapper) => {
      const flkty = new Flickity( sliderWrapper, {
        accessibility: true,
        cellAlign: "left",
        cellSelector: '[data-feature-slide]',
        pageDots: false,
        prevNextButtons: true,
        groupCells: 2,
      });
    });
  }

  updateProductDetails(variantImage, variantComparePrice, variantPrice, variantCtaLabel) {
    const featuredImageEl = this.querySelector('[data-product-image]');
    if (featuredImageEl && !featuredImageEl.disabled) {
      featuredImageEl.src = variantImage;
      featuredImageEl.srcset = '';
    }
    
    const showComparePrice = variantComparePrice.toString().trim() !== 'false' && variantComparePrice.toString().trim() !== variantPrice.toString().trim();
    const showVariantPrice = variantPrice !== 'false';
    
    // Update compare-at-price
    const compareAtPriceEl = this.querySelector('[data-compare-at-price]');
    if (compareAtPriceEl) {
      compareAtPriceEl.classList.toggle('hidden', !showComparePrice);
      compareAtPriceEl.textContent = showComparePrice ? variantComparePrice : '';
    }
    // Update variant price
    const variantPriceEl = this.querySelector('[data-price]');
    if (variantPriceEl) {
      variantPriceEl.classList.toggle('hidden', !showVariantPrice);
      variantPriceEl.classList.toggle('sale', showComparePrice);
      variantPriceEl.textContent = showVariantPrice ? variantPrice : '';      
    }
    // Update sale badge
    const saleBadgeEl = this.querySelector('[data-badge-sales]');
    if (saleBadgeEl) {  
      saleBadgeEl.classList.toggle('hidden', !showComparePrice);
    }
    const atcButton = this.querySelector('.product-tile__add-to-cart');
    if (atcButton && variantCtaLabel) {
        atcButton.textContent = variantCtaLabel;
    }
  }

  updateVariantSelection(variantSwatch) {
    this.querySelectorAll('[data-variant-swatch]').forEach((el) => {
      if (el.isSameNode(variantSwatch)) {
        el.classList.add('selected');
        el.setAttribute('aria-pressed', 'true');
        return;
      }
      el.classList.remove('selected');
      el.setAttribute('aria-pressed', 'false');
    });
  }

  updateAtcInput(variantId, isDisabled) {
    if (isDisabled) return;

    const atcInputEl = this.querySelector('[data-atc-input]');
    if (atcInputEl) {
      atcInputEl.value = variantId;
    }
  }
}

customElements.define('product-tile', ProductTile);
